/**
 * @generated SignedSource<<6b7244eb24db93c44864e31bdd470d3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpPricingOptimizationVariant_item$data = {
  readonly isSold: boolean | null;
  readonly isUnpurchasable: boolean | null;
  readonly " $fragmentType": "usePdpPricingOptimizationVariant_item";
};
export type usePdpPricingOptimizationVariant_item$key = {
  readonly " $data"?: usePdpPricingOptimizationVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpPricingOptimizationVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpPricingOptimizationVariant_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnpurchasable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "fae0368c5b508d0d26fd2d7419b69c4b";

export default node;
